import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {Exemption_3_6} from '@portbase/bezoekschip-service-typescriptmodels';
import {Observable, of} from "rxjs";

@Component({
    selector: 'app-visit-exemptions-exemption-3-6',
    templateUrl: './exemption_3_6.component.html',
    styleUrls: ['./exemption_3_6.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_3_6Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_3_6;

  searchReasons = (term: string): Observable<string[]> => of(["Push test", "Pull test", "Rolling out and retracting the tow rope"]
    .filter(value => !term || value.toLowerCase().includes(term.toLowerCase())));

  newReason = (value: string): string => value;
}

